<template>
  <div class="dropdown dropdown-author-action ">
    <button class="btn-outline btn btn-xs btn-info dropdown-toggle" :id="'dropdownMenu-'+author.authorID"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" :class="{active: author.selected}">
      <template v-if="!$user.isBasic()"> <i class="pe-7s-more pe-1x fa-rotate-90"></i></template>
      <template v-else> Contact ...</template>
    </button>
    <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu1" style="float: right" >
      <template v-if="context.name === 'expertSelected'">
        <li><a role="button" @click="dropDownClick('removeAuthor', $event)"><i class="fa fa-trash text-danger"></i> Remove expert</a></li>
        <li class="expert-list-action-li-follow">
          <a v-if="author.followSearchId === null" role="button" @click="dropDownClick('followSearch', $event)"><i class="fas fa-star text-info"></i> Monitor expert</a>
          <a v-else role="button" @click="dropDownClick('unFollowSearch', $event)"><i class="far fa-star text-info"></i> UnMonitor expert</a>
        </li>
        <li><a role="button" @click="dropDownClick('edit', $event)"><i class="fa fa-edit text-warning"></i> Edit expert</a></li>
      </template>
      <template v-else-if="context.name === 'expertSimilar'">
        <li><a role="button" @click="dropDownClick('addAuthor', $event)"><i class="fa fa-user-plus text-success"></i> Add expert</a></li>
        <li class="expert-list-action-li-follow">
          <a v-if="author.followSearchId === null" role="button" @click="dropDownClick('followSearch', $event)"><i class="fas fa-star text-info"></i> Monitor expert</a>
          <a v-else role="button" @click="dropDownClick('unFollowSearch', $event)"><i class="far fa-star text-info"></i> UnMonitor expert</a>
        </li>
        <li><a role="button" @click="dropDownClick('removeAuthor', $event)"><i class="fa fa-trash text-danger"></i> Remove expert</a></li>
        <li><a role="button" @click="dropDownClick('edit', $event)"><i class="fa fa-edit text-warning"></i> Edit expert</a></li>
      </template>
      <template v-else-if="context.name === 'expertResult'">
        <template v-if="author.selected">
          <template v-if="$user.isBasic()">
            <li class="expert-list-action-li-search"><a role="button" @click="dropDownClick('search', $event)"><i class="fa fa-search text-info"></i> Search expert</a></li>
            <li class="expert-list-action-li-follow">
              <a v-if="author.followSearchId === null" role="button" @click="dropDownClick('followSearch', $event)"><i class="fas fa-star text-info"></i> Monitor expert</a>
              <a v-else role="button" @click="dropDownClick('unFollowSearch', $event)"><i class="far fa-star text-info"></i> UnMonitor expert</a>
            </li>
          </template>
          <template v-else>
            <li><a role="button" @click="dropDownClick('removeAuthor', $event)"><i class="fa fa-trash text-danger"></i> Remove Expert</a></li>
            <li v-if="author.similar_authors && author.similar_authors.length !== 0" class="expert-list-action-li-add-similar"><a role="button" @click="dropDownClick('addSimilarAuthor', $event)" class="expert-list-action-li-add-similar"><i class="fa fa-users text-success"></i> Add expert & {{author.similar_authors.length}} similars</a></li>
            <li class="expert-list-action-li-search"><a role="button" @click="dropDownClick('search', $event)"><i class="fa fa-search text-info"></i> Search expert</a></li>
            <li class="expert-list-action-li-follow">
              <a v-if="author.followSearchId === null" role="button" @click="dropDownClick('followSearch', $event)"><i class="fas fa-star text-info"></i> Monitor expert</a>
              <a v-else role="button" @click="dropDownClick('unFollowSearch', $event)"><i class="far fa-star text-info"></i> UnMonitor expert</a>
            </li>
            <li role="separator" class="divider"></li>
            <li><a role="button" @click="dropDownClick('edit', $event)"><i class="fa fa-edit text-warning"></i> Edit expert</a></li>
          </template>
        </template>
        <template v-else>
          <template v-if="$user.isBasic()">
            <li>
              <a role="button" @click="dropDownClick('addAuthor', $event)" title="Subscribe to advanced Account">
                <i class="fa fa-user-plus text-success"></i> Add expert <i class="fa fa-lock font-bold"></i>
              </a>
            </li>
            <li class="expert-list-action-li-follow">
              <a v-if="author.followSearchId === null" role="button" @click="dropDownClick('followSearch', $event)"><i class="fas fa-star text-info"></i> Monitor expert</a>
              <a v-else role="button" @click="dropDownClick('unFollowSearch', $event)"><i class="far fa-star text-info"></i> UnMonitor expert</a>
            </li>
            <li class="expert-list-action-li-search"><a role="button" @click="dropDownClick('search', $event)"><i class="fa fa-search text-info"></i> Search expert</a></li>
          </template>
          <template v-else>
            <li><a role="button" @click="dropDownClick('addAuthor', $event)"><i class="fa fa-user-plus text-success"></i> Add expert</a></li>
            <li v-if="author.similar_authors && author.similar_authors.length !== 0" class="expert-list-action-li-add-similar">
              <a role="button" @click="dropDownClick('addSimilarAuthor', $event)" >
                <i class="fa fa-users text-success"></i> Add expert & {{author.similar_authors.length}} similars
              </a>
            </li>
            <li class="expert-list-action-li-search"><a role="button" @click="dropDownClick('search', $event)"><i class="fa fa-search text-info"></i> Search expert</a></li>
            <li class="expert-list-action-li-follow">
              <a v-if="author.followSearchId === null" role="button" @click="dropDownClick('followSearch', $event)"><i class="fas fa-star text-info"></i> Monitor expert</a>
              <a v-else role="button" @click="dropDownClick('unFollowSearch', $event)"><i class="far fa-star text-info"></i> UnMonitor expert</a>
            </li>
            <li role="separator" class="divider"></li>
            <li><a role="button" @click="dropDownClick('edit', $event)"><i class="fa fa-edit text-warning"></i> Edit expert</a></li>
          </template>
        </template>
      </template>

      <template v-else-if="context.name === 'documentResult'">
        <template v-if="author.selected">
          <li ><a role="button" @click="dropDownClick('removeAuthor', $event)"><i class="fa fa-trash text-danger"></i> Remove Expert</a></li>
          <li role="separator" class="divider"></li>
          <li><a role="button" @click="dropDownClick('edit', $event)"><i class="fa fa-edit text-warning"></i> Edit expert</a></li>
        </template>
        <template v-else>
          <li><a role="button" @click="dropDownClick('addAuthor', $event)"><i class="fa fa-user-plus text-success"></i> Add expert</a></li>
          <li role="separator" class="divider"></li>
          <li><a role="button" @click="dropDownClick('edit', $event)"><i class="fa fa-edit text-warning"></i> Edit expert</a></li>
        </template>
      </template>
    </ul>

    <edit-author v-if="author" ref="editAuthor" v-model="author" class="text-left"></edit-author>

  </div>
</template>

<style scoped>
  .dropdown-suggestion > ul > li i{
    color: #ffc107;
    font-weight: bold;
  }

  .dropdown-suggestion > ul > li a{
    font-size: 12px;
  }

  .dropdown-suggestion > ul > li{
    margin-bottom: 5px;
    font-size: 12px;
  }

</style>
<script>

import EditAuthor from '../modal/EditAuthor'
export default {
  components: {EditAuthor},
  props: ['value', 'context'],
  name: 'DropdownAuthor',
  data () {
    return {
      author: null
    }
  },
  watch: {
    value: function (value) {
      this.author = value
    },
    author: function (val) {
      this.$emit('input', this.author)
    }
  },
  methods: {
    dropDownClick: function (action, event) {
      event.preventDefault()
      let basicPlan = this.$user.isBasic()

      switch (action) {
        case 'removeAuthor':
          this.author.selected = false
          this.$emit('input', Object.assign({}, this.author))
          this.context.removeAuthor(this.author)
          break
        case 'addAuthor':
          if (basicPlan === false) {
            this.author.selected = true
          }
          this.$emit('input', Object.assign({}, this.author))
          this.context.addAuthor(this.author, 'author')
          break
        case 'addSimilarAuthor':
          if (basicPlan === false) {
            this.context.addAuthorSimilar(this.author, 'author')
          } else {
          }
          break
        case 'edit':
          if (basicPlan === false) {
            this.$refs.editAuthor.openModal()
          } else {
            this.context.showLimitPlan('editExpert')
          }
          break
        case 'search':
          this.context.searchAuthorByName(this.author, 'author')
          break
        case 'followSearch':
          let query = 'name:"' + this.author.firstName.replace(/\s/g, ' ').replace(/\./g, ' ').trim() +
            ' ' + this.author.lastName.trim() + '"'
          this.context.followSearch(query)
          break
        case 'unFollowSearch':
          this.context.unFollowSearch(this.author.followSearchId)
          // this.author.followSearchId = null
          break
      }

      $('#dropdownMenu-' + this.author.authorID).dropdown('toggle')

      if (typeof event.stopPropagation !== 'undefined') {
        event.stopPropagation()
      }
    }
  },
  beforeMount () {
    this.author = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DropdownAuthor.vue